import { render, staticRenderFns } from "./ConstructionsMap.vue?vue&type=template&id=1c952dcc&scoped=true&"
import script from "./ConstructionsMap.vue?vue&type=script&lang=js&"
export * from "./ConstructionsMap.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionsMap.vue?vue&type=style&index=0&id=1c952dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c952dcc",
  null
  
)

export default component.exports